module.exports = __webpack_public_path__ + "img/default-cover.96397374.webp";